import { Box, LinearProgress, Typography } from "@mui/material";
import { useTranslation } from "react-i18next";
import type { DetectedEffect } from "../../types";

interface DetectedEffectsPanelProps {
  effects: DetectedEffect[];
}

export const DetectedEffectsPanel = ({
  effects,
}: DetectedEffectsPanelProps) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        gap: "12px",
      }}
    >
      <Typography
        sx={{
          fontSize: "var(--body-b3-12-regular-size, 12px)",
          fontFamily: 'var(--font-family, "AktivGrotesk")',
          fontWeight: 500,
          color: "var(--alias-text-on-white-primary, #000)",
        }}
      >
        {t("ldp_explore_image_results_detected_effects", "Detected Effects")}
      </Typography>
      <Box
        sx={{
          display: "flex",
          flexDirection: "column",
          gap: "var(--spacing8, 8px)",
        }}
      >
        {effects.map((effect) => (
          <Box
            key={effect.labelKey}
            sx={{
              display: "flex",
              alignItems: "center",
              gap: "var(--spacing8, 8px)",
            }}
          >
            <Typography
              sx={{
                fontSize: "var(--body-b3-12-regular-size, 12px)",
                color: "var(--alias-text-on-white-primary, #1a1a1a)",
                flex: 1,
              }}
            >
              {t(effect.labelKey)}
            </Typography>
            <LinearProgress
              variant="determinate"
              value={effect.percentage}
              sx={{
                flex: 4,
                height: 4,
                borderRadius: 2,
                backgroundColor:
                  "var(--alias-stroke-on-white-default, #d9d9d9)",
                "& .MuiLinearProgress-bar": {
                  backgroundColor: "var(--alias-text-on-white-brand, #009FE4)",
                  borderRadius: 2,
                },
              }}
            />
            <Typography
              sx={{
                fontSize: "var(--footnote-f1-10-regular-size, 10px)",
                color: "var(--alias-text-on-white-disable, #999)",
                minWidth: 30,
                textAlign: "right",
              }}
            >
              {effect.percentage}%
            </Typography>
          </Box>
        ))}
      </Box>
    </Box>
  );
};
